module.exports = __webpack_public_path__ + "static/fonts/Nunito-LightItalic.5d62829.woff2";